// extracted by mini-css-extract-plugin
export default {"container":"empresa_container__XOBQa","title":"empresa_title__L5h1Q"};